// src/features/security/components/SecurityTimelineCard.tsx
import { Card } from '../../../app/components/foundation';
import type { SecurityTimelineEvent } from '../data/security.mock';

export interface SecurityTimelineCardProps {
  timeline: SecurityTimelineEvent[];
}

/**
 * Workspace card: chronological timeline for this security module
 * (policy, access, alert, change events). Same markup/CSS pattern as
 * customers/components/CustomerActivityCard.tsx and
 * orders/components/OrderTimelineCard.tsx — dot markers colored by
 * event type, event title, timestamp. No new UI pattern introduced.
 */
export function SecurityTimelineCard({ timeline }: SecurityTimelineCardProps) {
  return (
    <Card className="vania-security-workspace-card">
      <h2 className="vania-security-workspace-card-title">تاریخچه امنیتی</h2>

      {timeline.length === 0 ? (
        <p className="vania-security-workspace-empty">رویدادی برای این ماژول ثبت نشده است.</p>
      ) : (
        <ol className="vania-security-workspace-timeline">
          {timeline.map((event) => (
            <li key={event.id} className="vania-security-workspace-timeline-item">
              <span
                aria-hidden
                className={`vania-security-workspace-timeline-dot vania-security-workspace-timeline-dot-${event.type}`}
              />
              <div className="vania-security-workspace-timeline-body">
                <span className="vania-security-workspace-timeline-type">{event.title}</span>
                <span className="vania-security-workspace-timeline-date">{event.date}</span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
